// extracted by mini-css-extract-plugin
module.exports = {"root":"Vignette_root__jrqX6","wrapper":"Vignette_wrapper__2qW0U"};